import { View } from "./View"
import { ReactNode } from "react"

export function Screen({ children }: { children?: ReactNode }) {

  return <View style={{ width: "100vw", flexDirection: "column", alignItems: "center" }}>{children}</View>
}
